'use client'
import React, { useEffect, useState } from 'react'
import Image from 'next/image'

export interface GradientBallsProps {
  className?: string
  density?: 'low' | 'medium' | 'high' | 'extreme'
  size?: 'small' | 'medium' | 'large' | 'massive'
  opacity?: number
  variant?: 'standard' | 'merged' | 'cosmic'
}

export const GradientBalls: React.FC<GradientBallsProps> = ({
  className = '',
  opacity = 0.8,
  variant = 'merged',
}) => {
  const [documentHeight, setDocumentHeight] = useState('100vh')

  useEffect(() => {
    const updateHeight = () => {
      const height = Math.max(
        document.body.scrollHeight,
        document.documentElement.scrollHeight,
        window.innerHeight,
      )
      setDocumentHeight(`${height}px`)
    }

    updateHeight()

    // Update height when content changes
    const resizeObserver = new ResizeObserver(updateHeight)
    resizeObserver.observe(document.body)

    // Also listen for window resize
    window.addEventListener('resize', updateHeight)

    return () => {
      resizeObserver.disconnect()
      window.removeEventListener('resize', updateHeight)
    }
  }, [])

  return (
    <div
      className={className}
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        width: '100%',
        height: documentHeight,
        zIndex: -40,
        pointerEvents: 'none',
        opacity,
        mixBlendMode: variant === 'merged' ? 'screen' : 'normal',
      }}
    >
      <Image
        src="/gradient-balls.png"
        fill
        alt="background"
        style={{
          objectFit: 'cover',
        }}
        aria-hidden="true"
      />
    </div>
  )
}
